var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "india",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.333,
    height: 26.5,
    viewBox: "0 0 35.333 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9268",
    "data-name": "Path 9268",
    d: "M0,0H35.333V8.833H0Z",
    fill: "#f93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9269",
    "data-name": "Path 9269",
    d: "M0,160H35.333v8.833H0Z",
    transform: "translate(0 -151.167)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9270",
    "data-name": "Path 9270",
    d: "M0,320H35.333v8.833H0Z",
    transform: "translate(0 -302.333)",
    fill: "#128807"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(11.483 5.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 3.443,
    cy: 3.635,
    rx: 3.443,
    ry: 3.635,
    transform: "translate(2.808 3.917)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 3.061,
    cy: 3.061,
    r: 3.061,
    transform: "translate(3.191 4.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 0.618,
    cy: 0.618,
    r: 0.618,
    transform: "translate(5.565 6.882)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0.566 5.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(2.924 2.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(1.791 0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9271",
    "data-name": "Path 9271",
    d: "M-1.814,9.138l.106-1.855L-1.814,6.4l-.106.883Z",
    transform: "translate(1.92 -6.277)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9272",
    "data-name": "Path 9272",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.815, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9273",
    "data-name": "Path 9273",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9274",
    "data-name": "Path 9274",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 4.516, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(1.791 0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-3",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9275",
    "data-name": "Path 9275",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9276",
    "data-name": "Path 9276",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.815, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-4",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9277",
    "data-name": "Path 9277",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9278",
    "data-name": "Path 9278",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "matrix(-0.5, 0.866, -0.866, -0.5, 11.136, 3.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(2.924 2.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b",
    transform: "translate(1.791 0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-5",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9279",
    "data-name": "Path 9279",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9280",
    "data-name": "Path 9280",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.815, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-6",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9281",
    "data-name": "Path 9281",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9282",
    "data-name": "Path 9282",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 4.516, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b",
    transform: "translate(1.791 0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-7",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9283",
    "data-name": "Path 9283",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9284",
    "data-name": "Path 9284",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.815, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-8",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9285",
    "data-name": "Path 9285",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9286",
    "data-name": "Path 9286",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "matrix(-0.5, -0.866, 0.866, -0.5, 6.85, 13.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c",
    transform: "translate(2.924 2.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b",
    transform: "translate(1.791 0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-9",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9287",
    "data-name": "Path 9287",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9288",
    "data-name": "Path 9288",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.815, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-10",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9289",
    "data-name": "Path 9289",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9290",
    "data-name": "Path 9290",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 4.516, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b",
    transform: "translate(1.791 0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-11",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9291",
    "data-name": "Path 9291",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9292",
    "data-name": "Path 9292",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.815, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-12",
    "data-name": "a",
    transform: "translate(0.797 0.035)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9293",
    "data-name": "Path 9293",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.741, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 0.155,
    cy: 0.155,
    r: 0.155,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 3.038, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9294",
    "data-name": "Path 9294",
    d: "M.106,2.738.212.883.106,0,0,.883Z",
    transform: "translate(0 0.123)",
    fill: "#008"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.753f4df3b5a7ac8cdaf8fe86a0a38e84.svg";
export { ForwardRef as ReactComponent };